var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { fontSize, lineHeight, themeGet } from 'styled-system';
import { Button } from './Button';
export var linkStyles = function (props) {
    var normalBrand = themeGet('colors.brand.normal')(props);
    var gray = themeGet('colors.text')(props);
    var orange = themeGet('colors.orange.70')(props);
    var textDecoration = props.textDecoration || 'none';
    return (props.styled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      text-decoration: ", ";\n      cursor: pointer;\n\n      &:hover,\n      &:focus {\n        color: ", ";\n\n        text-decoration: underline;\n        text-decoration-color: ", ";\n      }\n\n      &:active {\n        color: ", ";\n        text-decoration: none;\n      }\n    "], ["\n      color: ", ";\n      text-decoration: ", ";\n      cursor: pointer;\n\n      &:hover,\n      &:focus {\n        color: ", ";\n\n        text-decoration: underline;\n        text-decoration-color: ", ";\n      }\n\n      &:active {\n        color: ", ";\n        text-decoration: none;\n      }\n    "])), gray, textDecoration, normalBrand, normalBrand, orange));
};
/**
 * @deprecated
 *
 * Still used by Shop-Reboot
 * Use ButtonLink from common/components/Button instead for new components
 */
var LinkButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /* Shop-Reboot :'( */\n  color: white !important;\n  text-decoration: none !important;\n"], ["\n  /* Shop-Reboot :'( */\n  color: white !important;\n  text-decoration: none !important;\n"])));
LinkButton.defaultProps = __assign(__assign({}, Button.defaultProps), { as: 'a' });
export { LinkButton };
var SecondaryLinkButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  /* Shop-Reboot :'( */\n  text-decoration: none !important;\n\n  ", ";\n  ", ";\n"], ["\n  /* Shop-Reboot :'( */\n  text-decoration: none !important;\n\n  ", ";\n  ", ";\n"])), lineHeight, fontSize);
SecondaryLinkButton.defaultProps = __assign(__assign({}, Button.defaultProps), { as: 'a', kind: 'secondary' });
export { SecondaryLinkButton };
export var Link = styled.a(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: inherit;\n  text-decoration: none;\n\n  ", ";\n\n  ", ";\n  ", ";\n"], ["\n  color: inherit;\n  text-decoration: none;\n\n  ", ";\n\n  ", ";\n  ", ";\n"])), linkStyles, fontSize, lineHeight);
Link.defaultProps = {
    styled: true,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
